export const ON_PROGRESS_DATA = 'boilderplate/UploadedData/ON_PROGRESS_DATA';

 export const LOADER_STATUS = 'boilderplate/UploadedData/LOADER_STATUS';

 export const EXCELL_TABLE_STATUS = 'boilderplate/UploadedData/EXCELL_TABLE_STATUS';

 export const SET_FILE_DATA = 'boilderplate/UploadedData/SET_FILE_DATA';

 export const SET_OTP_BOX = 'boilderplate/UploadedData/SET_OTP_BOX';

 export const SET_DIFF_TABLE = 'boilderplate/UploadedData/SET_DIFF_TABLE';

 export const OTP_INVALID = 'boilderplate/UploadedData/OTP_INVALID';

 export const SET_SUMMARY_TABLE = 'boilderplate/UploadedData/SET_SUMMARY_TABLE';

 export const SET_SUMMARY_TABLE_DATA = 'boilderplate/UploadedData/SET_SUMMARY_TABLE_DATA';

 export const SET_DIFF_TABLE_DATA = 'boilderplate/UploadedData/SET_DIFF_TABLE_DATA';

export const SET_HEADING = 'boilderplate/UploadedData/SET_HEADING';

export const SET_PLEASEWAIT = 'boilderplate/UploadedData/SET_PLEASEWAIT';

export const SET_TOTAL_RECORD = 'boilderplate/UploadedData/SET_TOTAL_RECORD';

export const ERROR_MODAL = 'boilderplate/PreviewAndSubmit/ERROR_MODAL';

export const SET_MASTER_FILE_DATA = 'SET_MASTER_FILE_DATA';

export const GET_ITEM = 'GET_ITEM';

export const TOTAL_ITEM_RECORDS = 'TOTAL_ITEM_RECORDS';

export const TXN_RECORD = 'TXN_RECORD';

export const ITEMS_TABLE_STATUS = 'ITEMS_TABLE_STATUS';

export const GET_PREPARE_GSTR = 'GET_PREPARE_GSTR';

export const ON_GSTR_SUMMARY = 'boilderplate/UploadedData/ON_GSTR_SUMMARY';

export const ON_GSTR_SUMMARY_AMD = 'boilderplate/UploadedData/ON_GSTR_SUMMARY_AMD';

export const SET_NIL_DATA = 'boilderplate/UploadedData/SET_NIL_DATA';

export const SET_DOC_ISSUE_DATA = 'boilderplate/UploadedData/SET_DOC_ISSUE_DATA'

export const PROFILE_INFO = 'boilerplate/UploadPage/PROFILE_INFO';

export const SET_AUTO_POPULATED_HISTORY = 'boilderplate/UploadedData/SET_AUTO_POPULATED_HISTORY';

export const SET_RECO_HISTORY = 'boilderplate/UploadedData/SET_RECO_HISTORY';

export const SET_RECONCILE_HISTORY = 'boilderplate/UploadedData/SET_RECONCILE_HISTORY';

export const SET_RECONCILE_DATA = 'boilderplate/UploadedData/SET_RECONCILE_DATA';

export const SET_HSN_DATA = 'boilderplate/UploadedData/SET_HSN_DATA';

export const SET_AUTODRAFTED_HISTORY = 'boilerplate/UploadPage/SET_AUTODRAFTED_HISTORY';

export const SET_PREPAREGSTR9_DATA = 'boilerplate/UploadPage/SET_PREPAREGSTR9_DATA';

export const SET_CLEAR_DATA = 'boilerplate/UploadPage/SET_CLEAR_DATA';

